<template>
  <el-select
    class="base-select"
    v-bind="$attrs"
    :class="[`base-select-${color}`]"
    v-on="$listeners"
    clearable
    placeholder="请选择"
  >
    <slot />
  </el-select>
</template>

<script>
export default {
  name: 'BaseSelect',
  components: {},
  props: {
    // 决定于边框的颜色
    color: {
      type: String,
      default: 'blue',
    },
  },
}
</script>

<style lang="less" scoped>
.base-select {
  &.base-select-blue {
    /deep/ .el-input__inner {
      border-color: #e1e1e1;
      height: 36px;
      &[disabled] {
        color: #606266;
        border-color: #e1e1e1;
      }
      &:focus {
        border-color: #3a6bd5;
      }
    }
    /deep/ .el-input__suffix {
      .el-select__caret {
        color: #e1e1e1;
      }
    }
  }
}
</style>
